import React from 'react';
import Products from "../../components/Products_page/Products_Page/Products";

const MomBaby = () => {
  return <div>
      <div className="products-wrap">
        <Products />
        </div>
  </div>;
};

export default MomBaby;
